import {createReducer} from "typesafe-actions";
import update from "immutability-helper";
import {UserState} from "../types/users";
import {cleanApiKey, createdApiKeys, gotApiKeys, gotArchetypes, gotCallbacks, gotUserCredits, setCreating, setLoading, setUser} from "../actions/users";

const initialState: UserState = {
    user: undefined,
    loading: false,
    creatingCredential: false,
};

export const usersReducer = createReducer(initialState)
    .handleAction(setUser, (state, action) => update(state, {
        user: {$set: action.payload.user},
    }))
    .handleAction(setLoading, (state, action) => update(state, {
        loading: {$set: action.payload},
    }))
    .handleAction(gotApiKeys, (state, action) => update(state, {
        credentials: {$set: action.payload},
    }))
    .handleAction(createdApiKeys, (state, action) => update(state, {
        generatedCredential: {$set: action.payload},
    }))
    .handleAction(setCreating, (state, action) => update(state, {
        creatingCredential: {$set : action.payload},
    }))
    .handleAction(cleanApiKey, (state) => update(state, {
        generatedCredential: {$set: undefined},
    }))
    .handleAction(gotUserCredits, (state, action) => update(state, {
        credits: {$set: action.payload},
    }))
    .handleAction(gotCallbacks, (state, action) => update(state, {
        callbacks: {$set: action.payload},
    }))
    .handleAction(gotArchetypes, (state, action) => update(state, {
        archetypes: {$set: action.payload},
    }))
;
